import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AdminRoute } from './components/AdminRoute';
import { DashboardLayout } from './components/Layout/DashboardLayout';
import { SignIn } from './pages/auth/SignIn';
import { SignUp } from './pages/auth/SignUp';
import { Dashboard } from './pages/Dashboard';
import { Tutors } from './pages/Tutors';
import { TutorDetail } from './pages/TutorDetail';
import { TutorPayoutInvoice } from './pages/TutorPayoutInvoice';
import { Students } from './pages/Students';
import { StudentDetail } from './pages/StudentDetail';
import { Sessions } from './pages/Sessions';
import { TopUps } from './pages/TopUps';
import { Reports } from './pages/Reports';
import { UserManagement } from './pages/UserManagement';
import { Profile } from './pages/Profile';
import { Debug } from './pages/Debug';
import { Boards } from './pages/Boards';
import { RoleRoute } from './components/RoleRoute';
import { canUseBoards, canUseTutoringPages } from './lib/roles';

function App() {
  useEffect(() => {
    // Set dark mode by default
    document.documentElement.classList.add('dark');
  }, []);

  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/sign-up" element={<SignUp />} />
          {/* Standalone (no dashboard chrome) so printing yields a clean document */}
          <Route
            path="/invoice/tutor-payouts"
            element={
              <ProtectedRoute>
                <AdminRoute>
                  <TutorPayoutInvoice />
                </AdminRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<RoleRoute allow={(r) => r !== 'intake'} redirect><Dashboard /></RoleRoute>} />
            <Route path="tutors" element={<AdminRoute><Tutors /></AdminRoute>} />
            <Route path="tutors/:id" element={<AdminRoute><TutorDetail /></AdminRoute>} />
            <Route path="students" element={<RoleRoute allow={canUseTutoringPages}><Students /></RoleRoute>} />
            <Route path="students/:id" element={<RoleRoute allow={canUseTutoringPages}><StudentDetail /></RoleRoute>} />
            <Route path="sessions" element={<RoleRoute allow={canUseTutoringPages}><Sessions /></RoleRoute>} />
            <Route path="topups" element={<RoleRoute allow={canUseBoards}><TopUps /></RoleRoute>} />
            <Route path="reports" element={<RoleRoute allow={canUseTutoringPages}><Reports /></RoleRoute>} />
            <Route path="boards" element={<RoleRoute allow={canUseBoards}><Boards /></RoleRoute>} />
            <Route path="settings" element={<Navigate to="/dashboard/boards" replace />} />
            <Route path="users" element={<AdminRoute><UserManagement /></AdminRoute>} />
            <Route path="profile" element={<Profile />} />
            <Route path="debug" element={<Debug />} />
          </Route>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
